export default "__VITE_ASSET__CPtFiIRs__"